module.exports = __webpack_public_path__ + "media/images/lb/867-19e189312d7dd51824e494f48429ac68.svg";